import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { Button } from '@/shared/ui/button';

interface LoadingButtonProps {
  children: ReactNode;
  isLoading?: boolean;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  onClick?: () => void;
  className?: string;
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
  icon?: LucideIcon;
  loadingText?: string;
}

export function LoadingButton({
  children,
  isLoading = false,
  disabled = false,
  type = 'button',
  onClick,
  className = 'w-full h-12 btn-accent text-base font-medium',
  variant = 'default',
  icon: Icon,
  loadingText,
}: LoadingButtonProps) {
  return (
    <Button
      type={type}
      className={className}
      disabled={isLoading || disabled}
      onClick={onClick}
      variant={variant}
    >
      {isLoading ? (
        <span className="flex items-center gap-2">
          <div className="h-5 w-5 animate-spin rounded-full border-2 border-accent-foreground/30 border-t-accent-foreground" />
          {loadingText || children}
        </span>
      ) : (
        <span className="flex items-center gap-2">
          {Icon && <Icon className="h-5 w-5" />}
          {children}
        </span>
      )}
    </Button>
  );
}
